'use client';
import IconCirclePlus from '@mnd-frontend/icons/components/CirclePlus';
import { GREY_800, SPACING_1_5 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const AddButtonStyles = styled.button<{ $topMargin: string }>`
  background: none;
  border: 0;
  padding: 0;
  margin: ${({ $topMargin }) => $topMargin} 0 0;
  > span {
    display: flex;
    gap: ${SPACING_1_5};
    align-items: center;
    color: ${GREY_800};
  }
  font-size: 0.875rem;
  font-weight: 400;
`;

export const AddButton = ({
  topMargin = '1.5rem',
  onClick,
  disabled,
  testId,
  children,
}: {
  topMargin?: string;
  onClick: () => void;
  disabled?: boolean;
  testId: string;
  children: string;
}) => {
  return (
    <AddButtonStyles
      data-testid={testId}
      type="button"
      onClick={onClick}
      disabled={disabled}
      $topMargin={topMargin}
    >
      <span>
        <IconCirclePlus $color="GREY_1000" $size="sm" />
        <span>{children}</span>
      </span>
    </AddButtonStyles>
  );
};
